import { Box, CircularProgress, Collapse, Fade } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { TransitionGroup } from 'react-transition-group';
import { actions } from 'services/store/ai';
import aiMusicGenerator from 'services/locales/en/aiMusicGenerator';
import { StoreRootState } from 'services/store/types';
import aiMusicGeneratorApi from 'services/api/aiMusicGenerator';
import FormulaItem from '../FormulaItem';
import ErrorMessage from './components/ErrorMessage';
import FormulaItemContainer from './components/FormulaItemContainer';
import { PrimaryGenreSelectorContainer as PrimaryGenreSelector } from './components/PrimaryGenreSelector';

const FormulaEditor = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { error, isLoading: loading } =
    aiMusicGeneratorApi.useGetAiMusicGeneratorGenresQuery();
  const formula = useSelector((store: StoreRootState) => store.ai.formula);

  const primaryGenre = useSelector(
    (store: StoreRootState) => store.ai.primaryGenre
  );

  return (
    <Box width="100%">
      {error && <ErrorMessage />}
      {loading && (
        <Box display="flex" justifyContent="center" m={4}>
          <CircularProgress />
        </Box>
      )}
      {!loading && !error && primaryGenre && (
        <Box display="flex" flexDirection="column">
          <PrimaryGenreSelector
            genre={primaryGenre}
            onPrimaryGenreChange={(genre: string) =>
              dispatch(actions.setPrimaryGenre({ primaryGenre: genre }))
            }
            onMicroGenreChange={(genre: string) =>
              dispatch(actions.setMicroGenre({ microGenre: genre }))
            }
          />
          <TransitionGroup
            component={Box}
            display="flex"
            flexDirection="column"
          >
            {formula
              .slice()
              .reverse()
              .map((field) => (
                <Collapse key={field.field}>
                  <Box paddingTop={{ xs: 1, md: 2 }}>
                    <Fade in timeout={500}>
                      <Box>
                        <FormulaItemContainer
                          key={field.field}
                          label={t(
                            aiMusicGenerator.formulaFieldLabels[field.field]
                          )}
                          onClose={() =>
                            dispatch(
                              actions.deleteFormulaField({ field: field.field })
                            )
                          }
                        >
                          <FormulaItem field={field} />
                        </FormulaItemContainer>
                      </Box>
                    </Fade>
                  </Box>
                </Collapse>
              ))}
          </TransitionGroup>
        </Box>
      )}
    </Box>
  );
};

export default FormulaEditor;
